/**
 * Netlify Identity is only needed on the public site to accept an invitation
 * or reset a password: the links sent by email point to the site root with a
 * token in the URL hash. The widget is loaded on demand in that case only.
 *
 * The deep import path bypasses the IgnorePlugin that gatsby-plugin-netlify-cms
 * adds for "netlify-identity-widget" when enableIdentityWidget is false.
 */
export const onInitialClientRender = () => {
  const hash = window.location.hash
  if (!/(confirmation|invite|recovery|email_change)_token=|access_token=|error=access_denied/.test(hash)) {
    return
  }
  import("netlify-identity-widget/build/netlify-identity").then(({ default: netlifyIdentity }) => {
    netlifyIdentity.on("init", user => {
      if (!user) {
        netlifyIdentity.on("login", () => {
          document.location.href = "/admin/"
        })
      }
    })
    netlifyIdentity.init()
  })
}

/**
 * Don't prefetch the data and code of every page linked from the current
 * one (≈ 11 requests per page): resources are loaded on hover or on click.
 */
export const disableCorePrefetching = () => true
